import { ReactNode } from 'react';
import { PATHS } from '@belong/common';
import { FlowHeader } from 'src/components/flow-header/flow-header';

type ResidentApplicationLayoutProps = {
  /**
   * Where the header's EXIT link points.
   *
   * Defaults to the resident's account page, which is the right destination for
   * the signed-in steps of the flow. `get-started` and `invitation` are public
   * routes though — they're excluded from
   * `PROTECTED_PATHS_PATTERNS.RESIDENT_APPLICATION` — so a signed-out visitor can
   * reach this layout, and `/accounts/*` would only bounce them off the protected
   * route guard. Those pages pass a destination anyone can open instead.
   */
  exitHref?: string;
};

export const getResidentApplicationLayout = (
  page: ReactNode,
  pageProps?: ResidentApplicationLayoutProps,
) => {
  return (
    <div className="relative flex min-h-full flex-col">
      <FlowHeader
        exitHref={pageProps?.exitHref || PATHS.RESIDENTS_ACCOUNT_TOURS_AND_APPS}
        whiteThemeRoutes={[
          PATHS.RESIDENT_APPLICATION_GET_STARTED,
          PATHS.RESIDENT_APPLICATION_INVITATION,
        ]}
      />
      <main className="md:mt-md">{page}</main>
    </div>
  );
};
